/**
 * お知らせ
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/notifications`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
      display_end_at: null
    },
    condition: {
      limit: 50,
      display_end_at: null,
      title: null,
      use_important: false,
      notification_type: null,
      format: 'json'
    },
  }
}

const notification = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ dispatch, commit, state }, { display_end_at, title, use_important, notification_type, page, limit, format }) {
      dispatch('saveCondition', {
        display_end_at: display_end_at,
        title: title,
        use_important: use_important,
        notification_type: notification_type,
        limit: limit
      })
      const params = {
        display_end_at: state.condition.display_end_at,
        title: state.condition.title,
        use_important: state.condition.use_important,
        notification_type: state.condition.notification_type,
        limit: state.condition.limit,
        page: page,
        format: format
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.DRIVER_NOTIFICATION, { content }) 
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 既読化
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { display_end_at, title, use_important, notification_type, limit}) {
      const _display_end_at = (display_end_at !== undefined) ? display_end_at : state.condition.display_end_at
      const _title = (title !== undefined) ? title : state.condition.title
      const _use_important = (use_important !== undefined) ? use_important : state.condition.use_important
      const _notification_type = (notification_type !== undefined) ? notification_type : state.condition.notification_type
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = {
        display_end_at: _display_end_at,
        title: _title,
        use_important: _use_important,
        notification_type: _notification_type,
        limit: _limit
      }
      commit(types.DRIVER_NOTIFICATION_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_NOTIFICATION_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_NOTIFICATION_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_NOTIFICATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_NOTIFICATION_CONDITION] (state, { params }) {
      state.condition.display_end_at = params.display_end_at,
      state.condition.title = params.title,
      state.condition.use_important = params.use_important,
      state.condition.notification_type = params.notification_type
      state.condition.limit = params.limit
    },
  },
}

export default notification

